export const REGISTRATION = {
  nameInput: "registration-name-input",
  surnameInput: "registration-surname-input",
  mobileInput: "registration-mobile-input",
  continueButton: "registration-continue-button",
  errorMessage: "registration-error-message",
};

export const NAV = {
  logo: "nav-denso-logo",
  homeTab: "nav-home-tab",
  trainingManualTab: "nav-training-manual-tab",
  productGuideTab: "nav-denso-catalogue-tab",
  mobileMenuButton: "nav-mobile-menu-button",
  participantBadge: "nav-participant-badge",
  restartButton: "nav-restart-session-button",
};
